import { render, staticRenderFns } from "./Editsector.vue?vue&type=template&id=dafed734&"
import script from "./Editsector.vue?vue&type=script&lang=js&"
export * from "./Editsector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports